module.exports = __webpack_public_path__ + "FSA Blog Copy.pdf";